// extracted by mini-css-extract-plugin
module.exports = {"baseBoxShadow":"0 5px 38px 0 rgba(25,27,61,0.1)","marginSmall":"1rem","container":"Error500_container__1ZSWE","info":"Error500_info__1WJGA"};